import { SECONDARY_SIDEBAR_WIDTH, SIDEBAR_COLLAPSED_WIDTH } from './_constants';
import { SecondarySidebarState } from './_types';

/**
 * Returns the grid column width for the sidebar.
 * For hover-expanded state, we keep the grid at collapsed width so the
 * sidebar panel overlays the content — enabling smooth CSS width transitions
 * without triggering a content reflow on every hover.
 * Only when pinned does the sidebar actually reserve space in the grid.
 */
export function calculateGridSidebarWidth(
  noSidebar: boolean,
  sidebarState: SecondarySidebarState
): number {
  if (noSidebar) {
    return 0;
  }
  if (sidebarState === 'pinned') {
    return SECONDARY_SIDEBAR_WIDTH;
  }
  return SIDEBAR_COLLAPSED_WIDTH;
}
